import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type UiChromeStoreType = {
  isHidden: boolean;

  hide: () => void;
  show: () => void;
  toggle: () => void;
  reset: () => void;
};

const useUiChrome = create<UiChromeStoreType>((set, get) => ({
  isHidden: false,

  hide: () => {
    if (get().isHidden) return;
    set({ isHidden: true });
  },

  show: () => {
    if (!get().isHidden) return;
    set({ isHidden: false });
  },

  toggle: () => {
    set(({ isHidden }) => ({ isHidden: !isHidden }));
  },

  reset: () => {
    if (!get().isHidden) return;
    set({ isHidden: false });
  },
}));

export const useIsChromeHidden = () => useUiChrome((state) => state.isHidden);

export const useUiChromeActions = () =>
  useUiChrome(
    useShallow((state) => ({
      hide: state.hide,
      show: state.show,
      toggle: state.toggle,
      reset: state.reset,
    })),
  );

export const { getState: getUiChromeState } = useUiChrome;

export default useUiChrome;
